import { createStore, createLogger } from 'vuex';
import app from './modules/app';
import login from './modules/login';
import reward from './modules/reward';

const state = {
    debug:
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname === 'localhost'
};

export default createStore({
    modules: {
        app,
        login,
        reward,
    },
    state,
    strict: state.debug,
    plugins: state.debug ? [createLogger()] : []
})